import React from 'react';

import { noop } from 'lodash';
import { useNavigate } from 'react-router';

import { IBaseProps } from '@rbi-ctg/frontend';
import { Modal, ModalSize } from 'components/modal';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { ServiceMode, useOrderContext } from 'state/order';
import { useStoreContext } from 'state/store';
import { routes } from 'utils/routing';

import { PickupModeContent } from './pickup-mode-content';

interface IPickupModeModalProps extends IBaseProps {
  allowsDismiss?: boolean;
  redirectUrl: string;
}

export const PickupModeModal = ({ allowsDismiss = true, redirectUrl }: IPickupModeModalProps) => {
  const { resetStore } = useStoreContext();

  const {
    selectServiceMode,
    reorder: { pendingReorder, handleReorder },
  } = useOrderContext();

  const enableNewFlow = useFlag(LaunchDarklyFlag.ENABLE_NEW_SERVICE_MODE_FLOW);
  const navigate = useNavigate();
  const handleSelectServiceMode = (mode: ServiceMode) => {
    const url = redirectUrl || routes.menu;

    selectServiceMode(mode).then(() => {
      if (pendingReorder) {
        handleReorder(pendingReorder, url);

        return;
      }

      navigate(url);
    });
  };

  return (
    <Modal
      size={enableNewFlow ? ModalSize.LANDSCAPE : ModalSize.SMALL}
      allowsDismiss={allowsDismiss}
      onDismiss={
        allowsDismiss
          ? () => {
              resetStore();
              navigate('../');
            }
          : noop
      }
      eventData={{
        modalAppearanceEventMessage: 'Select Pickup Mode',
      }}
    >
      <PickupModeContent selectServiceMode={handleSelectServiceMode} />
    </Modal>
  );
};
